import React from "react";
import { REQUEST_TYPES, STATUS_STYLES } from "@/lib/crmConstants";

export function RequestTypeBadge({ requestType }) {
  const cfg = REQUEST_TYPES[requestType];
  if (!cfg) return null;
  const s = STATUS_STYLES[cfg.color] || STATUS_STYLES.contact_us;
  return (
    <span
      data-testid={`request-type-badge-${requestType}`}
      className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-mono font-medium border"
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
    >
      {cfg.label}
    </span>
  );
}

export function StageBadge({ stage, requestType }) {
  const cfg = REQUEST_TYPES[requestType];
  const s = STATUS_STYLES[cfg?.color] || STATUS_STYLES.contact_us;
  const terminal = ["Won", "Lost", "Closed", "Completed", "Onboarded", "Delivered & invoiced", "Registered", "Active coverage", "Claim/Expiry"];
  const isDanger = stage === "Lost";
  const isSuccess = terminal.includes(stage) && !isDanger;
  const bg = isDanger ? "#FEE2E2" : isSuccess ? "#DCFCE7" : s.bg;
  const text = isDanger ? "#991B1B" : isSuccess ? "#166534" : s.text;
  const border = isDanger ? "#FCA5A5" : isSuccess ? "#86EFAC" : s.border;
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border"
      style={{ backgroundColor: bg, color: text, borderColor: border }}
    >
      {stage}
    </span>
  );
}
